import React from 'react';
import { Skeleton, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';

const SimilarModelsLoading = () => (
  <Skeleton
    data-testid="fulfillment__similar-models-loading"
    component="span"
    disablePadding
    grow
  >
    <SkeletonLine variant="single" />
    <SkeletonBlock aspect="wide" height={10} width={36} />
  </Skeleton>
);

export { SimilarModelsLoading };
